import {useRef} from 'react';
import type {RefObject} from 'react';
import {useResizeObserver} from '@sail/ui';
import {postMessageToEmbedder} from 'src/v2/util/embeddedMessages';

export const useNotifyParentHeight = (
  nodeRef: RefObject<HTMLElement> | null,
): void => {
  const lastHeight = useRef<number>(0);

  useResizeObserver({
    node: nodeRef,
    handler: (entry) => {
      const height = Math.ceil(entry.contentRect.height);
      if (height !== lastHeight.current) {
        lastHeight.current = height;
        postMessageToEmbedder({type: 'RESIZE', payload: {height}});
      }
    },
  });
};
